import {useState, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Routes, Route, Outlet, Navigate, useLocation, useNavigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {GetAllComment, UserIdForComment} from '../../../../Redux/AdminPanel/CommentSlice'
import {QuickMsg} from '../../../../Redux/AdminPanel/QuickMessageSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import Comments from '../../CommentDrawner/Comments'
import {
  DeleteStaffAccount,
  UpdateStatusStaff,
} from '../../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {DeleteUserAccount} from '../UserListSlice/UserListSlice'
import AssignStaff from './AssignStaff'

import Billing from './Billing'
import CreateNotification from './modal/CreateNotification'
import More from './More'
import Overview from './Overview'
import Profile from './UserProfile'
import {
  UpdateStatusForOwner,
  UpdateAssigneTo,
} from './UserProfileDetailSlice/UserProfileDetailSlice'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {adminLoginAsUser} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {reset, resetRedux} from '../../../../Redux/store'
import {toast} from 'react-toastify'
import Settings from './Settings'
import Referral from './Referral'
import React from 'react'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {useAdminUpdateSalesTypeMutation} from '../../../../../services/cellcast'
import { MenuComponent } from '../../../../../_metronic/assets/ts/components'

const UserProfileDetails = () => {
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const param: any = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////
  const [data, setData] = useState<any>({})
  const [notify, setNotify] = useState(false)
  const [deletePopup, setDeletePopup] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [userId, setUserId] = useState<any>('')
  const [quickMessagePopup, setQuickMessagePopup] = useState(false)
  const Role = GeneralDataOFLoginUser()?.role
  const userRoleId = GeneralDataOFLoginUser()?._id

  const userData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const ProfileDetatileState = userProp?.user ? userProp.user : userData

  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////
  useEffect(() => {
    setData(ProfileDetatileState)
  }, [ProfileDetatileState])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteUserAccount({
          userIds: [ProfileDetatileState?._id],
        })
      )
      navigate('/user-list')
    }
  }, [confirm])

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP  ///////////////////////////////////////////////

  const notification = useMemo(
    () => <CreateNotification show={notify} handleClose={() => setNotify(false)} />,
    [notify]
  )
  const ConfirmDelete = useMemo(
    () => (
      <DeleteConfirmationPopup
        Message={'Are you sure you want to Delete this user profile?'}
        show={deletePopup}
        confirm={() => setConfirm(true)}
        handleClose={() => setDeletePopup(false)}
      />
    ),
    [deletePopup]
  )

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP ///////////////////////////////////////////////

  ////////////////////////FUNTIONS FOR DIFFERENT OPERATIONS/////////////////////////////////////

  const handleCombineStatus = (status: string) => {
    dispatch(
      UpdateStatusForOwner({
        userId: data?._id,
        status2: status,
      })
    )
  }

  ////////COMMENT PART HANDLE //////////////////////////////
  const handleComment = (id: any) => {
    dispatch(UserIdForComment({id: id}))
    dispatch(
      GetAllComment({
        userId: id?._id,
      })
    )
  }

  const openQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        handleClose={() => setQuickMessagePopup(false)}
        show={quickMessagePopup}
        contacts={[{value: ProfileDetatileState?.mobile, label: ProfileDetatileState?.mobile}]}
        //  valid={valid} setValid={setValid} virtualNumber={virtualNumber}
      />
    ),
    [quickMessagePopup]
  )

  const handleLoginUser = () => {
    localStorage.setItem('isAdminAsUserRefresh', 'true')
    dispatch(resetRedux())
    let data = {
      email: ProfileDetatileState.email,
      userid: ProfileDetatileState._id,
    }
    dispatch(adminLoginAsUser(data)).then((res: any) => {
      if (!!res?.error && !res?.payload) {
        localStorage.setItem('isAdminAsUserRefresh', 'false')
        navigate('/auth/admin')
      }
    })
  }

  const [updateSalesType] = useAdminUpdateSalesTypeMutation()

  const handleUpdateSalesType = (userId: string, salesType: string) => {
    dispatch(startLoadding())
    updateSalesType({
      userId: userId,
      salesType: salesType,
    })
      .then((res: any) => {
        if (res?.data?.status) {
          toast.success(res.data?.message)
        } else {
          toast.error(res?.data?.message)
          console.error('Error update message flow :', res?.data?.message)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        dispatch(stopLoading())
      })
  }

  const handleAssignToMe = () => {
    const payload: any = {}

    if (Role === 'accountManager') {
      payload.accountManagerId = userRoleId
    }

    if (Role === 'sales') {
      payload.salesId = userRoleId
    }

    if (Role === 'staffAdmin') {
      payload.salesId = userRoleId
    }

    payload.userId = ProfileDetatileState._id
    dispatch(startLoadding())
    dispatch(UpdateAssigneTo(payload)).then((response: any) => {
      const res = response?.payload
      if (res.status) {
        toast.success(res.message)
      }
    })
  }

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [ProfileDetatileState])

  return (
    <>
      {notification}
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && openQuickMessage}
      {ConfirmDelete}
      <Routes>
        <Route
          element={
            <>
              <div className='row'>
                <Profile />
                <div className='col-md-8'>
                  <div className='d-flex justify-content-between'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder'>
                      <li
                        className='nav-item cursor-pointer'
                        onClick={() =>
                          navigate('/user-profile/overview', {
                            state: location.state,
                          })
                        }
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'overview' && 'active'
                          } `}
                        >
                          Overview
                        </span>
                      </li>

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() =>
                          navigate('/user-profile/billing', {
                            state: location.state,
                          })
                        }
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'billing' && 'active'
                          } `}
                        >
                          Billing
                        </span>
                      </li>

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() =>
                          navigate('/user-profile/referral', {
                            state: location.state,
                          })
                        }
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'referral' && 'active'
                          } `}
                        >
                          Referral
                        </span>
                      </li>

                      {!isUserWhiteLabel && (
                        <li
                          className='nav-item cursor-pointer'
                          onClick={() =>
                            navigate('/user-profile/assignStaff', {
                              state: location.state,
                            })
                          }
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) == 'assignStaff' && 'active'
                            } `}
                          >
                            Assigned Staff
                          </span>
                        </li>
                      )}
                      {ProfileDetatileState?.role == 'owner' ? (
                        <li
                          className='nav-item cursor-pointer'
                          onClick={() =>
                            navigate('/user-profile/setting', {
                              state: location.state,
                            })
                          }
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) == 'setting' && 'active'
                            } `}
                          >
                            Setting
                          </span>
                        </li>
                      ) : null}
                      <li
                        className='nav-item cursor-pointer'
                        onClick={() =>
                          navigate('/user-profile/more', {
                            state: location.state,
                          })
                        }
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'more' && 'active'
                          } `}
                        >
                          More
                        </span>
                      </li>
                    </ul>
                    <div className='d-flex my-4'>
                      <div className='me-0'>
                        <button
                          className='btn btn-primary'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions
                          <span className='svg-icon svg-icon-primary svg-icon-2 ms-2 me-0'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              xmlnsXlink='http://www.w3.org/1999/xlink'
                              width='24px'
                              height='24px'
                              viewBox='0 0 24 24'
                              version='1.1'
                            >
                              <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                                <polygon points='0 0 24 0 24 24 0 24' />
                                <path
                                  d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
                                  fill='#ffffff'
                                  fillRule='nonzero'
                                  transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'
                                />
                              </g>
                            </svg>
                          </span>
                        </button>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
                          data-kt-menu='true'
                          style={{}}
                        >
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Contact
                            </div>
                          </div>
                          <div className='menu-item px-3'>
                            {AuthenticateUser('send-quick-sms') && (
                              <div className='aside-footer flex-column-auto '>
                                <a
                                  target='_blank'
                                  className='menu-link px-3'
                                  data-bs-toggle='tooltip'
                                  data-bs-trigger='hover'
                                  data-bs-dismiss-='click'
                                  title='Check out the complete documentation with over 100 components'
                                  onClick={() => setQuickMessagePopup(true)}
                                >
                                  Send quick message
                                </a>
                                {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                              </div>
                            )}
                          </div>
                          <div className='menu-item px-3'>
                            <a
                              href={`mailto:${ProfileDetatileState?.email}`}
                              className='menu-link px-3'
                            >
                              Send email
                            </a>
                          </div>
                          <div className='menu-item px-3'>
                            <span onClick={() => setNotify(true)} className='menu-link px-3'>
                              Add portal notification
                            </span>
                          </div>
                          <div className='menu-item px-3'>
                            <span onClick={handleLoginUser} className='menu-link px-3'>
                              Login as user
                            </span>
                          </div>
                          {Role !== 'superAdmin' && (
                            <div className='menu-item px-3'>
                              <span onClick={handleAssignToMe} className='menu-link px-3'>
                                Assign to me
                              </span>
                            </div>
                          )}

                          {!ProfileDetatileState?.salesType && (
                            <>
                              <div className='menu-item px-3'>
                                <span
                                  onClick={() =>
                                    handleUpdateSalesType(ProfileDetatileState?._id, 'outbound')
                                  }
                                  className='menu-link px-3'
                                >
                                  Set to outbond
                                </span>
                              </div>
                              <div className='menu-item px-3'>
                                <span
                                  onClick={() =>
                                    handleUpdateSalesType(ProfileDetatileState?._id, 'inbound')
                                  }
                                  className='menu-link px-3'
                                >
                                  Set to inbound
                                </span>
                              </div>
                            </>
                          )}

                          {ProfileDetatileState?.salesType === 'inbound' && (
                            <div className='menu-item px-3'>
                              <span
                                onClick={() =>
                                  handleUpdateSalesType(ProfileDetatileState?._id, 'outbound')
                                }
                                className='menu-link px-3'
                              >
                                Set to outbond
                              </span>
                            </div>
                          )}

                          {ProfileDetatileState?.salesType === 'outbound' && (
                            <div className='menu-item px-3'>
                              <span
                                onClick={() =>
                                  handleUpdateSalesType(ProfileDetatileState?._id, 'inbound')
                                }
                                className='menu-link px-3'
                              >
                                Set to inbound
                              </span>
                            </div>
                          )}

                          <div className='separator my-2' />
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Account
                            </div>
                          </div>
                          <div
                            className='menu-item px-3'
                            data-kt-menu-trigger='hover'
                            data-kt-menu-placement='right-end'
                          >
                            <span className='menu-link'>
                              <span className='menu-title'>Status</span>
                              <span className='menu-arrow' />
                            </span>
                            <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('active')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-success   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Active</span>
                                  {data?.status2 == 'active' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('inactive')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-secondary   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Inactive</span>

                                  {data?.status2 == 'inactive' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('suspended')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-danger   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Suspended</span>

                                  {data?.status2 == 'suspended' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='menu-item px-3'>
                            <span
                              onClick={() => handleComment(data)}
                              className='menu-link px-3 aside-footer flex-column-auto'
                              id='kt_drawer_chat_toggle2'
                            >
                              Comments
                            </span>
                          </div>

                          {AuthenticateUser('delete-user') && (
                            <div
                              className='menu-item px-3 my-1'
                              onClick={() => setDeletePopup(true)}
                            >
                              <a className='menu-link px-3 text-danger'>Delete client</a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <Outlet />
                </div>
              </div>
            </>
          }
        >
          <Route
            index
            element={<Navigate to='/user-profile/overview' state={location.state} replace={true} />}
          />

          <Route
            path='overview'
            element={
              <>
                <Overview />
              </>
            }
          />
          <Route
            path='billing'
            element={
              <>
                <Billing />
              </>
            }
          />
          <Route
            path='referral'
            element={
              <>
                <Referral />
              </>
            }
          />
          {!isUserWhiteLabel && (
            <Route
              path='assignStaff'
              element={
                <>
                  <AssignStaff />
                </>
              }
            />
          )}
          <Route
            path='setting'
            element={
              <>
                <Settings />
              </>
            }
          />
          <Route
            path='more'
            element={
              <>
                <More />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default UserProfileDetails
